module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "qtgs"
    }
  }, _vm._l((_vm.mes), function(one) {
    return _c('div', [_c('a', {
      attrs: {
        "download": "",
        "href": one.URL,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(one.TITLE))])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e3694f1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/xxgs/nr/qtgs.vue
// module id = 802
// module chunks = 2